import * as React from "react";
import User from "../../model/user/User";
import MapLegendEngineer from "./MapLegendEngineer";

interface ComponentProps {
	/**
	 * Checked sales engineers list.
	 */
	checkedSalesEngineers: User[],
	/**
	 * All sales engineers list.
	 */
	salesEngineers: User[]
	/**
	 * On sales engineer select.
	 * @param {string[]} users List of selected users
	 */
	onChange: (users: User[]) => void;
	/**
	 * Handles click on focus button on map legend row
	 * @param {User} user
	 */
	onFocusButtonClick: (user: User) => void;
}

type Props = ComponentProps;

/**
 * Map legend component.
 */
export default class MapLegendComponent extends React.Component <Props, {}> {
	render() {
		return (
			<div className="c-map-legend">
				{this.props.salesEngineers.map((se, index) => {
					return (
						<MapLegendEngineer user={se} key={index}
										   active={this.isSelected(se.id)}
										   onClick={(active) => this.toggleUser(se, active)}
										   onFocusButtonClick={this.props.onFocusButtonClick}/>
					)
				})}
			</div>
		);
	}

	toggleUser(user: User, isActive: boolean) {
		const checkedSe = isActive ? this.props.checkedSalesEngineers.filter(se => user.id != se.id) :
			this.props.checkedSalesEngineers.concat(user);
		this.props.onChange(checkedSe);
	}

	/**
	 * Indicates if user is selected
	 * @param {string} userId User identifier.
	 * @returns {boolean} True if is selected, false otherwise.
	 */
	isSelected(userId: string) {
		return this.props.checkedSalesEngineers.map(se => se.id).lastIndexOf(userId) != -1;
	}
}
